export default {
    carregando: false,
    items: [],
    subTiposHierarquias: [],
    macroTiposHierarquias: [],
    selecionado: {}
}